import { Component, OnDestroy, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { INDRAExtraSidebar } from '@ibe.components/shared/sidebar-views/ancillaries/extra-sidebar.indra.abstract';
import {
	EXTRAS_ANCILLARY_BAG, TRANSLATION_ANCILLARIES_TYPE, TRANSLATION_ANCILLARY_DETAILED, TRANSLATION_ANCILLARY_TEXTS, TRANSLATION_ANCILLARY_TITLE, TRANSLATION_EXTRA_BAGS, TRANSLATION_ANCILLARY_LABEL, ANCILLARY_PRODUCT_GROUP_CODE_HOLD_BAGGAGE, ANCILLARY_GROUP_HOLD_BAGGAGE_LIST, SSR_CODE_BAGGAGE_PRIORITY, SSR_CODE_BAGGAGE_FIRST_BAG, SSR_CODE_BAGGAGE_ADDITIONAL_BAG, SSR_CODE_BAGGAGE_SECOND_BAG, SSR_CODE_BAGGAGE_FIRST_BAG_X2, SSR_CODE_BAGGAGE_32_BAG_X2,
	SSR_CODE_BAGGAGE_FIRST_BAG_X3, SSR_CODE_BAGGAGE_32_BAG_X3, TRANSLATION_ANCILLARY_ARIA_LABEL, BUS_TRN_OPERATOR, EQUIPMENT_CODE_BUS, EQUIPMENT_CODE_TRAIN, BUSINESS_BRANDS, BRAND_CODE_EXECUTIVE, BRAND_CODE_TOP_EXECUTIVE, SESSION_VAR_KEY_LANGUAGE, DEFAULT_LANGUAGE, SESSION_VAR_KEY_MARKET, DEFAULT_MARKET, SPECIAL_CASE_MARKET_LANGUAGE_MAP
} from '@ibe.config';
import { INDRAAddOnAncillary } from '@ibe.models/ancillary.indra.model.lib';
import { INDRAAncillariesSelectionService } from '@ibe.services/ancillaries-selection.indra.service';
import { INDRABookingService } from '@ibe.services/booking.indra.service';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { INDRAMybService } from '@ibe/services';
import { SidebarService } from '@ibe/services/ui';
import { INDRAAncillariesShoppingCartService } from '@ibe.services/ancillaries-shopping-cart.indra.service';
import { INDRABFMDataStorageService } from '@ibe.services/bfm-data-storage.indra.service';
import { INDRABookedTripDetails, INDRAFareInformation } from '@ibe.models/booked-trip-details.indra.model.lib';
import { Subscription } from 'rxjs';
import { INDRADateService } from '@ibe.services/date.indra.service';
import { INDRABookingSearchService } from '@ibe.services/booking-search.indra.service';
import { INDRAStorageService } from '@ibe.services/storage.indra.service';
import { Store } from '@ngrx/store';
import * as fromStore from '@ibe/store/index';
import { INDRAGoogleAnalyticsService } from '@ibe.services/google.analytics.indra.service';
import { INDRAIbeAdminConfigService } from '@ibe.services/ibeadmin-config.service';
import { PaymentService } from '@ibe.components/shared/payment/payment.service';
import { INDRACurrencyPipe } from '@ibe.services/currency.indra.pipe';


@Component({
	selector: 'app-extra-bags',
	templateUrl: './extra-bags.indra.component.html',
	styleUrls: ['./extra-bags.component.scss'],
	host: {
		class: 'app-extra-bags'
	},
	providers: [INDRACurrencyPipe]
})
export class INDRAExtraBagsComponent extends INDRAExtraSidebar
	implements OnInit, OnDestroy {

	notificationMessage: string;

	formsPerPassenger: FormGroup[];

	translationAncillaryDetailedKey = TRANSLATION_ANCILLARY_DETAILED;

	bagCountPassenger: any = [];
	bagsCountPerPassenger = [];
	count: number = 0;

	booked_trip: INDRABookedTripDetails;
	includedAncillaries;
	bagBaseWeight;

	allSubscriptions: Subscription[] = [];
	paramSubscription: Subscription;
	loadedSubscription: Subscription;

	reviewFlights: boolean = false;

	aggregateSale: string = null;

	notificationShowing: boolean;
	lastActiveElement;
	notificationDuration = 2.5; // in seconds

	milesNeeded = 0;
	addedAncillary: any = [];
	removedAncillary: any;
	isModificationDisallowed: boolean = false;
	notEnoughMilesFlag: boolean = false;
	hasAddedExtrasFlag: any;

	@ViewChild('sidebar__notification') $notification: ElementRef;

	constructor(
		sidebarService: SidebarService,
		route: ActivatedRoute,
		router: Router,
		bookingService: INDRABookingService,
		mybService: INDRAMybService,
		ibeAdminService: INDRAIbeAdminService,
		ancillariesSelectionSrv: INDRAAncillariesSelectionService,
		ancillariesShoppingCartSrv: INDRAAncillariesShoppingCartService,
		private bfmStorageService: INDRABFMDataStorageService,
		private fb: FormBuilder,
		dateService: INDRADateService,
		googleAnalytics: INDRAGoogleAnalyticsService,
		private bookingSearchService: INDRABookingSearchService,
		storageService: INDRAStorageService,
		store: Store<fromStore.State>,
		private ibeAdminConfigService: INDRAIbeAdminConfigService,
		protected currencyPipe: INDRACurrencyPipe,
		protected paymentInfoService: PaymentService
	) {
		super(sidebarService, route, router, bookingService, mybService, ibeAdminService, ancillariesSelectionSrv, ancillariesShoppingCartSrv, EXTRAS_ANCILLARY_BAG, dateService, googleAnalytics, storageService, store, currencyPipe, paymentInfoService);
		this.formsPerPassenger = [];

		this.loadedSubscription = this.isLoaded.subscribe(
			res => {
				if (res) {
					this.showNotification('addMoreSidebars.specialMeals.texts.appliedSuccessfullyToOtherFlights');
				}
			}
		);
		this.allSubscriptions.push(this.loadedSubscription);

		// get 'isBookingCreated' if existing in URL query params (if true, modification in the sidebar is not allowed)
		const isBookingCreatedParam = this.route.snapshot.paramMap.get('isBookingCreated');
		if (isBookingCreatedParam === 'true') {
			this.isModificationDisallowed = true;
		}
	}

	ngOnInit() {
		this.storageService.set('ancType', EXTRAS_ANCILLARY_BAG); 
		this.paramSubscription = this.route.params.subscribe(params => {
			if (this.router.url.includes('/review-your-trip') || this.router.url.includes('/booking/payment')) this.reviewFlights = true;

			this.bagCountPassenger = [];
			this.flightCardId = params.flight;

			if (params.aggregateSale && params.aggregateSale != null && params.aggregateSale != undefined && params.aggregateSale != 'undefined') {
				this.aggregateSale = params.aggregateSale;
			}

			this.booked_trip = this.bfmStorageService.INDRA_getActiveBookedTrip();
			this.flight = this.bookingService.INDRA_getBookedFlight(this.flightCardId);
			this.includedAncillaries = this.INDRA_getIncludedAncillaries(this.flight.idFlight);
			this.bagBaseWeight = this.INDRA_determineBagBaseWeight(this.flight);
			this.INDRA_getBagCountPerPassenger(this.flight.idFlight, this.includedAncillaries);
			// this.flightRouteInput = (!this.aggregateSale) ? this.bookingService.INDRA_getFlightRoute(this.flight) : this.bookingService.INDRA_getFlightRouteAggregate(this.flight, this.aggregateSale);
			this.flightRouteInput = this.bookingService.INDRA_getFlightRoute(this.flight);
			this.passengers = this.bookingService.INDRA_getPaxInfo(false);
			this.passengers.forEach(passenger =>
				this.formsPerPassenger.push(this.createFormGroup())
			);

			super.ngOnInit();
		});



		for (const i in this.passengers) {
			const feature = this.INDRA_getAddedAncillariesForPassenger(this.passengers[i].idPax);
			if (feature.length != 0) {
				const shoppingCartItems = this.storageService.get('INDRAAncillariesShoppingCartService.shoppingCart');
				for (const x in feature) {
					this.addedAncillary.push(feature[x]);
					this.milesNeeded = this.milesNeeded + feature[x].points;
					// this.payWithMiles = shoppingCartItems.itemsAdded.find(item => item.type == feature[x].type).payWithMiles;
				}
			}
		}

		this.payWithMiles = this.INDRA_isPayWithMiles();

		this.allSubscriptions.push(this.paramSubscription);

		this.hasAddedExtrasFlag = this.INDRA_getInitialAddedExtras('BAG');
	}

	ngOnDestroy() {
		for (const sub of this.allSubscriptions) {
			if (sub) {
				sub.unsubscribe();
			}
		}
	}

	INDRA_gotoURL(key) {
		const languageCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
			sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE).toLowerCase() : DEFAULT_LANGUAGE;
		const languageMap = SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] ? SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] : languageCode;
		const marketCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
			sessionStorage.getItem(SESSION_VAR_KEY_MARKET).toLowerCase() : DEFAULT_MARKET;
		const urlIbeAdmin = this.ibeAdminConfigService.getConfigurationValue(key);
		const urlNavigate = urlIbeAdmin.replace('${lang}', `${languageMap}`).replace('${market}', `${marketCode}`);
		return window.open(urlNavigate);
	}




	INDRA_getIncludedAncillaries(flightId) {
		let filteredAncillaries = [];
		const fareInformation = this.booked_trip['fare-information'];
		if (fareInformation) {
			const flightIdfareInformation: INDRAFareInformation = fareInformation[flightId];
			if (flightIdfareInformation) {
				filteredAncillaries = flightIdfareInformation.ancillaries.filter((ancillary) => {
					return ANCILLARY_GROUP_HOLD_BAGGAGE_LIST.includes(ancillary) && ancillary !== SSR_CODE_BAGGAGE_PRIORITY;
				});
			}
		}
		return filteredAncillaries;
	}

	INDRA_determineBagBaseWeight(flight) {
		const fareFamily = this.reviewFlights ?
			this.bookingSearchService.INDRA_getBrandCodeFromAmadeus(flight.fareFamily) :
			this.bookingService.INDRA_getBrandCode(flight.fareFamily);
		if (BUSINESS_BRANDS.includes(fareFamily)) {
			return '32KG.';
		} else {
			return '23KG.';
		}
	}

	INDRA_getBagCountPerPassenger(flightId, includedAncillaries) {
		const tierInformation = this.booked_trip['tier-information'];
		const listPax = this.booked_trip.data.infoPax.listPax;
		// Get included from fare information.
		listPax.forEach((pax) => {
			this.count = 0;
			if (pax.typePax !== 'INF') {
				includedAncillaries.forEach((ancillary) => {
					this.INDRA_incrementCount(ancillary);
				});
			} else {
				if (includedAncillaries.length > 0) {
					this.count += 1;
				}
			}
			// Get included from purchased
			this.INDRA_getPurchasedBags(pax.idPax, flightId);
			// Get included from tier
			this.INDRA_getExtraBagsForTier(pax, tierInformation);

			const addedAnc = this.INDRA_getAddedAncillariesForPassenger(pax.idPax);
			addedAnc.forEach(anc => {
				if (anc.type === 'BAG' && anc.flightCardId == this.flightCardId && anc.paxId == pax.idPax && !anc['ssrTatto']) {
					this.count += 1;
				}
			});

			this.bagCountPassenger.push({ paxId: pax.idPax, count: this.count });
		});
	}

	INDRA_getPurchasedBags(paxId, flightId) {
		if (this.booked_trip.data.ancillaries && this.booked_trip.data.ancillaries.ancillaries) {
			this.booked_trip.data.ancillaries.ancillaries.forEach((ancillary) => {
				ancillary.journey.forEach((journey) => {
					if (journey.flightId == flightId) {
						if (journey.segmentId == this.INDRA_getFirstSegmentByFlight(flightId).toString()) {
							journey.passengers.forEach((passenger) => {
								if (passenger.paxId == paxId) {
									passenger.ancillaryInfo.forEach((info) => {
										this.INDRA_incrementCount(info.code, info.quantity);
									});
								}
							});
						}
					}
				});
			});
		} else {
			const shoppingCartItems = this.storageService.get('INDRAAncillariesShoppingCartService.shoppingCart');
			if (shoppingCartItems != null) {
				if (shoppingCartItems.itemsAdded.length != 0) {
					for (const i in shoppingCartItems.itemsAdded) {
						if (shoppingCartItems.itemsAdded[i].flightId == flightId) {
							// if (shoppingCartItems.itemsAdded[i].segmentId == this.INDRA_getFirstSegmentByFlight(flightId)) {
							if (shoppingCartItems.itemsAdded[i].paxId == paxId) {
								this.INDRA_incrementCount(shoppingCartItems.itemsAdded[i].code, 1);
							}
							// }
						}
					}
				}
			}
		}
	}

	INDRA_getFirstSegmentByFlight(flightId) {
		let segmentId = -1;
		this.booked_trip.data.fare.listOutbound.forEach((outbound) => {
			if (outbound.idFlight == flightId && segmentId === -1) {
				const listSegment = outbound.listSegment.filter(segment => segment.equipment !== EQUIPMENT_CODE_BUS && segment.equipment !== EQUIPMENT_CODE_TRAIN);
				segmentId = listSegment[0].idInfoSegment;
			}
		});
		if (segmentId === -1) {
			this.booked_trip.data.fare.listInbound.forEach((inbound) => {
				if (inbound.idFlight == flightId && segmentId === -1) {
					const listSegment = inbound.listSegment.filter(segment => segment.equipment !== EQUIPMENT_CODE_BUS && segment.equipment !== EQUIPMENT_CODE_TRAIN);
					segmentId = listSegment[0].idInfoSegment;
				}
			});
		}
		return segmentId;
	}

	INDRA_getExtraBagsForTier(pax, tierInformation) {
		const paxTier = pax['tierLevelFF'];
		if (paxTier) {
			if (tierInformation && tierInformation[paxTier] && tierInformation[paxTier].ancillaries) {
				const filteredTierAncillary = tierInformation[paxTier].ancillaries.filter((tierAncillary) => {
					return ANCILLARY_GROUP_HOLD_BAGGAGE_LIST.includes(tierAncillary) && tierAncillary !== SSR_CODE_BAGGAGE_PRIORITY;
				});
				if (pax.typePax !== 'INF') {
					filteredTierAncillary.forEach((filteredAncillary) => {
						this.INDRA_incrementCount(filteredAncillary);
					});
				}
			}
		}
	}

	INDRA_incrementCount(code, quantity = 1) {
		switch (code) {
			case SSR_CODE_BAGGAGE_FIRST_BAG:
			case SSR_CODE_BAGGAGE_ADDITIONAL_BAG:
			case SSR_CODE_BAGGAGE_SECOND_BAG: this.count += quantity; break;
			case SSR_CODE_BAGGAGE_FIRST_BAG_X2:
			case SSR_CODE_BAGGAGE_32_BAG_X2: this.count += 2; break;
			case SSR_CODE_BAGGAGE_FIRST_BAG_X3:
			case SSR_CODE_BAGGAGE_32_BAG_X3: this.count += 3; break;
		}
	}

	INDRA_getBagCountsPerPassenger(paxId) {
		const passengerCount = this.bagCountPassenger.filter((bagCount) => {
			return bagCount.paxId == paxId;
		})[0];


		return passengerCount.count;
	}


	INDRA_hasNextFlight() {
		return this.bookingService.INDRA_hasNextFlight(this.flightCardId);
	}

	INDRA_copyToOtherFlights() {
	}


	INDRA_flowActionsClasses() {
		return { 'flow_actions--wide': !this.INDRA_hasNextFlight() };
	}

	/**
	 * Handles next flight click;
	 * If there is a next flight, navigate to checked bags of with the next flight id;
	 * Else, Close the sidebar
	 */
	INDRA_handleNext() {
		const nextFlightIdentifier = this.bookingService.INDRA_getNextFlightCardId(this.flightCardId);
		if (nextFlightIdentifier > 0) {
			this.router.navigate([
				{ outlets: { sidebar: ['checked-bags', { flight: nextFlightIdentifier }] } }
			]);
		} else {
			super.INDRA_handleClose();
		}
	}

	INDRA_printAddButtonLabel(idPax: number) {
		const features = this.INDRA_getAddOnForPassenger(idPax);
		const feature = features[0];

		let baseWeight;
		feature.code === SSR_CODE_BAGGAGE_ADDITIONAL_BAG ? baseWeight = '23KG.' : baseWeight = this.bagBaseWeight;

		return this.INDRA_getTranslation(`${this.translationAncillaryDetailedKey + baseWeight + feature.code}`)
			+ ' ('
			+ this.currencyPipe.transform((feature.price)) + ' '
			+ this.INDRA_getCurrencySymbol(feature.currency)
			+ ')';
	}

	INDRA_printAddedButtonLabel(item: INDRAAddOnAncillary) {
		let baseWeight;
		item.code === SSR_CODE_BAGGAGE_ADDITIONAL_BAG ? baseWeight = '23KG.' : baseWeight = this.bagBaseWeight;
		return this.INDRA_getTranslation(`${this.translationAncillaryDetailedKey + baseWeight + item.code}`);
	}

	INDRA_printRemoveButtonLabel(item: INDRAAddOnAncillary) {
		return item.price + this.INDRA_getCurrencySymbol(item.currency);
	}

	private createFormGroup() {
		return this.fb.group({
			bagsAdd: null,
			weightCheck: false,
			dimensionCheck: false
		});
	}

	INDRA_getTitle() {
		return this.INDRA_getTranslation(`${TRANSLATION_ANCILLARIES_TYPE + EXTRAS_ANCILLARY_BAG}`);
	}

	INDRA_getTextTranslation(lastKey: string) {
		const key = TRANSLATION_EXTRA_BAGS + TRANSLATION_ANCILLARY_TEXTS + lastKey;
		return key;
	}

	INDRA_getTitleTranslation(lastKey: string) {
		const key = TRANSLATION_EXTRA_BAGS + TRANSLATION_ANCILLARY_TITLE + lastKey;
		return key;
	}

	INDRA_getLabelTranslation(lastKey: string) {
		const key = TRANSLATION_EXTRA_BAGS + TRANSLATION_ANCILLARY_LABEL + lastKey;
		return key;
	}

	INDRA_getAriaLabelTranslation(lastKey: string) {
		const key = TRANSLATION_EXTRA_BAGS + TRANSLATION_ANCILLARY_ARIA_LABEL + lastKey;
		return key;
	}

	INDRA_handleAddAncillaryForBags(addedItem: INDRAAddOnAncillary, paxId) {
		const passengerIndex = this.bagCountPassenger.findIndex((bag) => {
			return bag.paxId == paxId;
		});
		this.bagCountPassenger[passengerIndex].count += 1;

		this.addedAncillary.push(addedItem);
		this.milesNeeded = this.milesNeeded + addedItem.points;

		this.hasAddedExtrasFlag = this.INDRA_handleAddAncillary(addedItem)

	}

	INDRA_handleRemoveAncillaryForBag(removedItem: INDRAAddOnAncillary, paxId) {
		const passengerIndex = this.bagCountPassenger.findIndex((bag) => {
			return bag.paxId == paxId;
		});

		const addedBags = this.INDRA_getAddedAncillariesForPassenger(paxId);
		const removeLastItem = addedBags[addedBags.length - 1];
		this.bagCountPassenger[passengerIndex].count -= 1;
		this.addedAncillary = this.addedAncillary.filter(item => item.paxId != removeLastItem.paxId);

		this.milesNeeded = this.milesNeeded - removeLastItem.points;

		// removedItem -> removeLastItem remove always the last bag to fix issue / align with hierarchy
		this.hasAddedExtrasFlag = this.INDRA_handleRemoveAncillary(removeLastItem);

		// sessionStorage.removeItem("is"+EXTRAS_ANCILLARY_BAG+"withMiles");
		this.INDRA_checkMiles();

	}

	INDRA_getStopoverNotificationTitle() {
		return this.INDRA_getTranslation('addMoreSidebars.extraBags.titles.extraBagsForThe') + ' '
			+ this.INDRA_getBoundType() + ' ' +
			this.INDRA_getTranslation('addMoreSidebars.extraBags.titles.trip');
	}

	INDRA_getOperationErrorNotificationTitle() {
		return this.INDRA_getTranslation('addMoreSidebars.general.titles.operationError');
	}

	private showNotification(message: string) {
		this.notificationMessage = this.INDRA_getTranslation(message);
		this.notificationShowing = true;
		window.setTimeout(this.dismissNotification.bind(this), this.notificationDuration * 1000);

		this.lastActiveElement = document.activeElement;
		// this.$notification.nativeElement.focus();
	}

	dismissNotification() {
		this.notificationShowing = false;
		this.lastActiveElement.focus();
	}

	INDRA_processAncillary() {
		this.notEnoughMilesFlag = this.INDRA_handleProcessAncillaries(EXTRAS_ANCILLARY_BAG, this.addedAncillary, this.milesNeeded, this.booked_trip);
	}

	INDRA_checkMiles(){
		/* const flag = sessionStorage.getItem(EXTRAS_ANCILLARY_BAG);
		const isPaidWithMiles = sessionStorage.getItem("is"+EXTRAS_ANCILLARY_BAG+"withMiles");
		if(flag === null){
			return false;
		} else if(flag === 'true' && isPaidWithMiles === 'true'){
			return false;
		} else if (flag === 'false' && isPaidWithMiles === 'false'){
			return false;
		} else if(flag !== null && isPaidWithMiles === null){
			return false;

		}
		return true; */

		/* ------------------------------------- */

		
		const shoppingCartItems = this.storageService.get('INDRAAncillariesShoppingCartService.shoppingCart');
		const bagItems:any = [];
		if(shoppingCartItems.itemsAdded.length === 0 ){
				return false;
		} else if (shoppingCartItems.itemsAdded.length != 0){
				for (const i in shoppingCartItems.itemsAdded) {
					if(shoppingCartItems.itemsAdded[i].code === "FBAG"){

						bagItems.push(shoppingCartItems.itemsAdded[i]);

						if(bagItems.length < 1){
							return false;
						}

						const isPaidWithMiles = sessionStorage.getItem("is"+shoppingCartItems.itemsAdded[i].type+"withMiles") === 'true'
							? true
							: false;

						if(shoppingCartItems.itemsAdded[i].payWithMiles === isPaidWithMiles) {
							return false;
						} else {
							return true;
						}
					}
	
				}
		}

		return false;
		
	}
}
